import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "task-parameters-form" }
const _hoisted_2 = { class: "task-parameters-form_main" }
const _hoisted_3 = { class: "task-parameters-form_title" }

import { computed, onBeforeMount, onBeforeUnmount, PropType, ref, watch } from "vue";
import {
  ITaskParameters,
  TaskDifficultiesService,
  TaskParametersTemplateService,
  TaskPrioritiesService,
  TaskStatusesService,
  TaskStatusesServiceAdapter,
  TaskTagsService,
  TaskTypesService,
} from "./adapter-service";
import { TaskParameterModel, TaskParameterTypeEnum } from "@/components/task-parameter";
import { ParametersTemplateModel } from "./models";
import {
  TirPmButtonVariantEnum,
  TirPmButton,
  TirPmButtonSizeEnum,
  Tabs,
  Tab,
  TirPmNotificationEventBus,
  TirPmNotificationModel,
} from "tir-components";
import {
  ParametersEditForm,
  TemplatesListForm,
  TemplateEditForm,
  TemplateImportForm,
} from "./forms";
import { TirPmTabsVariantEnum } from "tir-pm-tabs/src/Enums";
import { TaskParametersLeave } from "./components";
import ApiService from "@/api";

/**Сервис для использования api шаблонов */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-parameters-form',
  props: {
  /**Id очереди */
  entityId: { type: String || Number },
  /**Тип настройки */
  type: { type: Number as PropType<TaskParameterTypeEnum> },
  /**Имя области */
  namespaceName: { type: String },
},
  emits: ["import"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;

const templateService = new TaskParametersTemplateService();
/**Сервис для использования API */
const apiService = ref<ITaskParameters>();

/**Параметры */

/**События */


/**Список шаблонов */
const templates = ref<ParametersTemplateModel[]>([]);
/**Список параметров */
const parameters = ref<TaskParameterModel[]>([]);
/**Редактируемый список параметров */
const editParameters = ref<TaskParameterModel[]>([]);
/**Заголовок формы */
const title = ref("");
/**Текущий открытый таб */
const currentTab = ref(0);
/**Редактирующийся шаблон */
const editingTemplate = ref<ParametersTemplateModel>();
/**Активна форма импорта шаблонов из других очередей */
const isImport = ref(false);
/**Окно для подтверждения закрытия настроек параметров */
const $taskParametersLeave = ref<InstanceType<typeof TaskParametersLeave>>();

/**Параметр рабочей области */
const isNamespaceParameter = computed(
  () => props.type == TaskParameterTypeEnum.Type || props.type == TaskParameterTypeEnum.Difficulty,
);
/**Есть изменения в параметрах */
const haveChanges = computed(() => {
  const jsonOriginal = JSON.stringify(parameters.value);
  const jsonEdited = JSON.stringify(editParameters.value);
  return jsonOriginal != jsonEdited;
});
/**Табы */
const tabs = computed(() => {
  return [
    { Id: 0, Name: title.value },
    { Id: 1, Name: "Мои шаблоны" },
  ];
});

/**Отслеживание изменения типа параметра */
watch(() => props.type, updateByType);

/**Перед рендером компонента */
onBeforeMount(() => {
  Promise.allSettled([updateByType(), getTemplates()]);
  window.addEventListener("beforeunload", windowOnBeforeUnload);
});
/**Перед удалением */
onBeforeUnmount(() => {
  window.removeEventListener("beforeunload", windowOnBeforeUnload);
});

/**Если не сохранены изменения, открывать окно для подтверждения закрытия страницы */
function windowOnBeforeUnload(event: BeforeUnloadEvent) {
  if (haveChanges.value) {
    event.preventDefault();
    event.returnValue = true;
  }
}
/**Обновление компонента по типу */
async function updateByType() {
  switch (props.type) {
    case TaskParameterTypeEnum.Status:
      title.value = "Статусы";
      apiService.value = new TaskStatusesServiceAdapter();
      break;
    case TaskParameterTypeEnum.Priority:
      title.value = "Приоритеты";
      apiService.value = new TaskPrioritiesService();
      break;
    case TaskParameterTypeEnum.Tag:
      title.value = "Теги";
      apiService.value = new TaskTagsService();
      break;
    case TaskParameterTypeEnum.Type:
      title.value = "Типы";
      apiService.value = new TaskTypesService();
      break;
    case TaskParameterTypeEnum.Difficulty:
      title.value = "Сложность";
      apiService.value = new TaskDifficultiesService();
      break;
  }

  getList();
}
/**Получение списка задач */
const getList = async () => {
  const response = await apiService.value.GetList(props.entityId);
  if (response.IsSuccess) {
    setParametersArrays(response.Value);
  }
};
/**Редактирование элемента */
const onUpsertParameter = (_parameter: TaskParameterModel) => {
  if (editParameters.value.length == 0) {
    _parameter.IsDefault = true;
  }
  if (_parameter.Id) {
    const parameter = editParameters.value.find((x) => x.Id == _parameter.Id);
    parameter.Name = _parameter.Name;
    parameter.Color = _parameter.Color;
  } else {
    editParameters.value.unshift(_parameter);
  }
};
/**Создание нового шаблона */
const createTemplate = async (template: ParametersTemplateModel) => {
  const response = await templateService.UpsertTemplate(template);
  if (response.IsSuccess) {
    getTemplates();
  }
};
/**Получение списка шаблонов */
const getTemplates = async () => {
  const response = await templateService.GetTemplateList(props.type);
  if (response.IsSuccess) {
    templates.value = response.Value;
  }
};
/**Удалить щаблон */
const removeTemplate = async (template: ParametersTemplateModel) => {
  const response = await templateService.RemoveTemplate(template.Id);
  if (response.IsSuccess) {
    templates.value = templates.value.filter((t) => t.Id != template.Id);
  }
};
/**Сохранить изменения */
const saveChanges = async () => {
  const response = await apiService.value.SetList(props.entityId, editParameters.value);

  if (isNamespaceParameter.value) sendUsedParamsRemoveNotification();
  if (response.IsSuccess) setParametersArrays(response.Value);
};
/**Отправка уведомлений об удалении использовавшихся параметров */
const sendUsedParamsRemoveNotification = () => {
  const removedParameters = parameters.value.filter(
    (p) => p.InUse && !editParameters.value.some((ep) => ep.Id == p.Id),
  );
  const basicParameter = editParameters.value.find((p) => p.IsDefault);
  removedParameters.forEach((parameter) => {
    TirPmNotificationEventBus.emit(
      "add",
      new TirPmNotificationModel({
        title: "Изменения внесены",
        subtitle: `Атрибут "${parameter?.Name}" удален и заменен в тикетах на атрибут "${basicParameter.Name}"`,
        type: "success",
        group: "general",
        life: 6000,
        colorIcon: "var(--status-inverted-positive)",
      }),
    );
  });
};
/**Установка значений переменных с параметрами */
const setParametersArrays = (array: TaskParameterModel[]) => {
  parameters.value = array;
  editParameters.value = array.map((p) => new TaskParameterModel(p));
};
/**Изменить имя шаблона */
const upsertTemplate = (template: ParametersTemplateModel) => {
  templateService.UpsertTemplate(template);
};
/**Выбор шаблона */
const selectParameters = (parameters: TaskParameterModel[]) => {
  currentTab.value = 0;

  const tempId = new Date().getTime();

  editParameters.value = editParameters.value.filter((p) => p.InUse);
  parameters.forEach((parameter, index) => {
    if (
      !editParameters.value.some(
        (p) => p.Name.toLocaleLowerCase() == parameter.Name.toLocaleLowerCase(),
      )
    ) {
      editParameters.value.push(
        new TaskParameterModel({
          ...parameter,
          InUse: false,
          IsDefault: false,
          Id: undefined,
          TempId: tempId + index,
        }),
      );
    }
  });
  const haveDefault = editParameters.value.some((p) => p.IsDefault);
  if (!haveDefault && editParameters.value.length) {
    editParameters.value[0].IsDefault = true;
  }
};
/**Очистка неиспользуемых параметров */
const clearUnused = () => {
  editParameters.value = editParameters.value.filter((parameter) => parameter.InUse);
};
/**Выбор редактируемого шаблона */
const setEditingTemplate = (template?: ParametersTemplateModel) => {
  editingTemplate.value = template;
};
/**Сохранить шаблон */
const editTemplate = (template: ParametersTemplateModel) => {
  upsertTemplate(template);
  Object.assign(editingTemplate.value, template);
  setEditingTemplate();
};
/**Открыть форму для импорты шаблонов */
const setImportForm = (_isImport: boolean) => {
  isImport.value = _isImport;
  setTimeout(() => emit("import", _isImport));
};
/**Импортировать параметры */
const importParameters = (parameters: TaskParameterModel[]) => {
  setImportForm(false);
  selectParameters(parameters);
};
/**Открыть окно с подтверждением выхода из настройки */
const openLeaveConfirmation = (callback?: Function) => {
  $taskParametersLeave.value?.toggle(true, callback);
};

/**Код для использования по ref */
__expose({
  haveChanges,
  setImportForm,
  openLeaveConfirmation,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (editingTemplate.value)
          ? (_openBlock(), _createBlock(_unref(TemplateEditForm), {
              key: 0,
              type: __props.type,
              template: editingTemplate.value,
              title: title.value,
              templates: templates.value,
              namespaceName: __props.namespaceName,
              onCancel: setEditingTemplate,
              onSave: editTemplate
            }, null, 8, ["type", "template", "title", "templates", "namespaceName"]))
          : (isImport.value)
            ? (_openBlock(), _createBlock(_unref(TemplateImportForm), {
                key: 1,
                type: __props.type,
                onImport: importParameters,
                onBack: _cache[0] || (_cache[0] = ($event: any) => (setImportForm(false)))
              }, null, 8, ["type"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(Tabs), {
                    modelValue: currentTab.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentTab).value = $event)),
                    variant: _unref(TirPmTabsVariantEnum).Secondary
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab, idx) => {
                        return (_openBlock(), _createBlock(_unref(Tab), {
                          key: idx,
                          val: tab.Id,
                          label: tab.Name,
                          currentTab: currentTab.value
                        }, null, 8, ["val", "label", "currentTab"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "variant"]),
                  _createVNode(_unref(TirPmButton), {
                    class: "task-parameters-form_title_save",
                    variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                    size: _unref(TirPmButtonSizeEnum).Small,
                    isDisabled: !haveChanges.value,
                    onClick: saveChanges
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Применить изменения ")
                    ]),
                    _: 1
                  }, 8, ["variant", "size", "isDisabled"])
                ]),
                (currentTab.value == 0)
                  ? (_openBlock(), _createBlock(_unref(ParametersEditForm), {
                      key: 0,
                      type: __props.type,
                      templates: templates.value,
                      editParameters: editParameters.value,
                      createTemplateDisabled: haveChanges.value,
                      title: title.value,
                      namespaceName: __props.namespaceName,
                      onUpsert: onUpsertParameter,
                      onClearUnused: clearUnused,
                      onCreateTemplate: createTemplate,
                      onSelectTemplate: selectParameters
                    }, null, 8, ["type", "templates", "editParameters", "createTemplateDisabled", "title", "namespaceName"]))
                  : _createCommentVNode("", true),
                (currentTab.value == 1)
                  ? (_openBlock(), _createBlock(_unref(TemplatesListForm), {
                      key: 1,
                      templates: templates.value,
                      type: __props.type,
                      onSelect: selectParameters,
                      onUpsert: upsertTemplate,
                      onEditCompound: setEditingTemplate,
                      onRemove: removeTemplate,
                      onImport: _cache[2] || (_cache[2] = ($event: any) => (setImportForm(true)))
                    }, null, 8, ["templates", "type"]))
                  : _createCommentVNode("", true)
              ], 64))
      ])
    ]),
    _createVNode(_unref(TaskParametersLeave), {
      ref_key: "$taskParametersLeave",
      ref: $taskParametersLeave
    }, null, 512)
  ], 64))
}
}

})